if(typeof Stripe !== 'undefined') {
  var stripe = Stripe(STRIPE_PUBLISHABLE_KEY);
} else {
  var stripe = undefined;
}

module.exports = stripe;
